<template>
    <div v-if="field.products" class="ProductList4">
         <section class="section home-section bg white pb-sm-5 pb-1 px-3 px-sm-0">
                <div class="inner-wrap container">
                    <div class="products-list set-4 row">
                        <div class="products-list__column col-xl-4">
                            <div class="row">
                                <div class="item w-100 mt-2 mb-2">
                                    <div v-if="field.products[0]" class="product type-e">
                                        <div class="d-flex">
                                            <div class="col-6 p-0 product__img">
                                                <div class="thumb">
                                                    <router-link :to="'products/item/'+field.products[0].id">
                                                        <img v-if="field.products[0].images[0]"
                                                        :src="[ field.products[0].images[0].url]">
                                                        <img v-else src="../../assets/img/default-noimg.png">
                                                    </router-link >
                                                </div>
                                            </div>
                                            <div class="col-6 product__content pr-sm-3 pr-1">
                                                <h5 class="ui text big-lg medium-md tiny-sm small semibold ">
                                                    <router-link :to="'products/item/'+field.products[0].id">{{field.products[0].titleTH}}</router-link>
                                                </h5>
                                                <div class="price">
                                                        <p class="ui text big-lg medium-md tiny-sm small bold [ color red-2 ] m-0">{{currency}}{{formatPrice(field.products[0].netPrice)}}</p>
                                                        <p v-if="field.products[0].netPrice != field.products[0].price" class="ui text big-lg medium-md tiny-sm small light line-through m-0">{{currency}}{{formatPrice(field.products[0].price)}}</p>
                                                    </div>
                                                <div class="d-flex align-items-center">
                                                    <div v-if="field.products[0].discountPercent != 0"><a class="ui yellow label p-sm-2 p-1"><span class="ui text color red-2">{{$t('sale')}}  <span class="ui text medium-sm tiny">{{field.products[0].discountPercent}}</span>%</span></a></div>
                                                    <div class="ml-auto">
                                                        <div class="d-flex align-items-center ml-auto">
                                                            <AddToCart v-if="field.products[0].quantity != 0" :btnStyle="'style1'" :product="field.products[0]" />
                                                            <span v-else class="badge badge-danger mr-2">{{$t('SoldOut')}}</span>
                                                            <Favorite :productId="field.products[0].id"></Favorite>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="item w-100 mt-2 mb-2">
                                    <div v-if="field.products[1]" class="product type-e">
                                        <div class="d-flex">
                                            <div class="col-6 p-0 product__img">
                                                <div class="thumb">
                                                    <router-link :to="'products/item/'+field.products[1].id">
                                                        <img v-if="field.products[1].images[0]"
                                                        :src="[ field.products[1].images[0].url]">
                                                        <img v-else src="../../assets/img/default-noimg.png">
                                                    </router-link >
                                                </div>
                                            </div>
                                            <div class="col-6 product__content pr-sm-3 pr-1">
                                                <h5 class="ui text big-lg medium-md tiny-sm small semibold ">
                                                    <router-link :to="'products/item/'+field.products[1].id">{{field.products[1].titleTH}}</router-link>
                                                </h5>
                                                <div class="price">
                                                        <p class="ui text big-lg medium-md tiny-sm small bold [ color red-2 ] m-0">{{currency}}{{formatPrice(field.products[1].netPrice)}}</p>
                                                        <p v-if="field.products[1].netPrice != field.products[1].price" class="ui text big-lg medium-md tiny-sm small light line-through m-0">{{currency}}{{formatPrice(field.products[1].price)}}</p>
                                                    </div>
                                                <div class="d-flex align-items-center">
                                                    <div v-if="field.products[1].discountPercent != 0"><a class="ui yellow label p-sm-2 p-1"><span class="ui text color red-2">{{$t('sale')}}  <span class="ui text medium-sm tiny">{{field.products[1].discountPercent}}</span>%</span></a></div>
                                                    <div class="ml-auto">
                                                        <div class="d-flex align-items-center ml-auto">
                                                            <AddToCart v-if="field.products[1].quantity != 0" :btnStyle="'style1'" :product="field.products[1]" />
                                                            <span v-else class="badge badge-danger mr-2">{{$t('SoldOut')}}</span>
                                                            <Favorite :productId="field.products[1].id"></Favorite>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="products-list__column col-xl-4">
                            <div class="row">
                                <div class="item w-100 mt-2 mb-2">
                                    <div v-if="field.products[2]" class="product type-e">
                                        <div class="d-flex">
                                            <div class="col-6 p-0 product__img">
                                                <div class="thumb">
                                                    <router-link :to="'products/item/'+field.products[2].id">
                                                        <img v-if="field.products[2].images[0]"
                                                        :src="[ field.products[2].images[0].url]">
                                                        <img v-else src="../../assets/img/default-noimg.png">
                                                    </router-link >
                                                </div>
                                            </div>
                                            <div class="col-6 product__content pr-sm-3 pr-1">
                                                <h5 class="ui text big-lg medium-md tiny-sm small semibold ">
                                                    <router-link :to="'products/item/'+field.products[2].id">{{field.products[2].titleTH}}</router-link>
                                                </h5>
                                                <div class="price">
                                                        <p class="ui text big-lg medium-md tiny-sm small bold [ color red-2 ] m-0">{{currency}}{{formatPrice(field.products[2].netPrice)}}</p>
                                                        <p v-if="field.products[2].netPrice != field.products[2].price" class="ui text big-lg medium-md tiny-sm small light line-through m-0">{{currency}}{{formatPrice(field.products[2].price)}}</p>
                                                    </div>
                                                <div class="d-flex align-items-center">
                                                    <div v-if="field.products[2].discountPercent != 0"><a class="ui yellow label p-sm-2 p-1"><span class="ui text color red-2">{{$t('sale')}}  <span class="ui text medium-sm tiny">{{field.products[2].discountPercent}}</span>%</span></a></div>
                                                    <div class="ml-auto">
                                                        <div class="d-flex align-items-center ml-auto">
                                                            <AddToCart v-if="field.products[2].quantity != 0" :btnStyle="'style1'" :product="field.products[2]" />
                                                            <span v-else class="badge badge-danger mr-2">{{$t('SoldOut')}}</span>
                                                            <Favorite :productId="field.products[2].id"></Favorite>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="item w-100 mt-2 mb-2">
                                    <div v-if="field.products[3]" class="product type-e">
                                        <div class="d-flex">
                                            <div class="col-6 p-0 product__img">
                                                <div class="thumb">
                                                    <router-link :to="'products/item/'+field.products[3].id">
                                                        <img v-if="field.products[3].images[0]"
                                                        :src="[ field.products[3].images[0].url]">
                                                        <img v-else src="../../assets/img/default-noimg.png">
                                                    </router-link >
                                                </div>
                                            </div>
                                            <div class="col-6 product__content pr-sm-3 pr-1">
                                                <h5 class="ui text big-lg medium-md tiny-sm small semibold ">
                                                    <router-link :to="'products/item/'+field.products[3].id">{{field.products[3].titleTH}}</router-link>
                                                </h5>
                                                <div class="price">
                                                        <p class="ui text big-lg medium-md tiny-sm small bold [ color red-2 ] m-0">{{currency}}{{formatPrice(field.products[3].netPrice)}}</p>
                                                        <p v-if="field.products[3].netPrice != field.products[3].price" class="ui text big-lg medium-md tiny-sm small light line-through m-0">{{currency}}{{formatPrice(field.products[3].price)}}</p>
                                                    </div>
                                                <div class="d-flex align-items-center">
                                                    <div v-if="field.products[3].discountPercent != 0"><a class="ui yellow label p-sm-2 p-1"><span class="ui text color red-2">{{$t('sale')}}  <span class="ui text medium-sm tiny">{{field.products[3].discountPercent}}</span>%</span></a></div>
                                                    <div class="ml-auto">
                                                        <div class="d-flex align-items-center ml-auto">
                                                            <AddToCart v-if="field.products[3].quantity != 0" :btnStyle="'style1'" :product="field.products[3]" />
                                                            <span v-else class="badge badge-danger mr-2">{{$t('SoldOut')}}</span>
                                                            <Favorite :productId="field.products[3].id"></Favorite>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="products-list__column col-xl-4">
                            <div class="row">
                                <div class="item w-100 mt-2 mb-2">
                                    <div v-if="field.products[4]" class="product type-e">
                                        <div class="d-flex">
                                            <div class="col-6 p-0 product__img">
                                                <div class="thumb">
                                                    <router-link :to="'products/item/'+field.products[4].id">
                                                        <img v-if="field.products[4].images[0]"
                                                        :src="[ field.products[4].images[0].url]">
                                                        <img v-else src="../../assets/img/default-noimg.png">
                                                    </router-link >
                                                </div>
                                            </div>
                                            <div class="col-6 product__content pr-sm-3 pr-1">
                                                <h5 class="ui text big-lg medium-md tiny-sm small semibold ">
                                                    <router-link :to="'products/item/'+field.products[4].id">{{field.products[4].titleTH}}</router-link>
                                                </h5>
                                                <div class="price">
                                                        <p class="ui text big-lg medium-md tiny-sm small bold [ color red-2 ] m-0">{{currency}}{{formatPrice(field.products[4].netPrice)}}</p>
                                                        <p v-if="field.products[4].netPrice != field.products[4].price" class="ui text big-lg medium-md tiny-sm small light line-through m-0">{{currency}}{{formatPrice(field.products[4].price)}}</p>
                                                    </div>
                                                <div class="d-flex align-items-center">
                                                    <div v-if="field.products[4].discountPercent != 0"><a class="ui yellow label p-sm-2 p-1"><span class="ui text color red-2">{{$t('sale')}}  <span class="ui text medium-sm tiny">{{field.products[4].discountPercent}}</span>%</span></a></div>
                                                    <div class="ml-auto">
                                                        <div class="d-flex align-items-center ml-auto">
                                                            <AddToCart v-if="field.products[4].quantity != 0" :btnStyle="'style1'" :product="field.products[4]" />
                                                            <span v-else class="badge badge-danger mr-2">{{$t('SoldOut')}}</span>
                                                            <Favorite :productId="field.products[4].id"></Favorite>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="item w-100 mt-2 mb-2">
                                    <div v-if="field.products[5]" class="product type-e">
                                        <div class="d-flex">
                                            <div class="col-6 p-0 product__img">
                                                <div class="thumb">
                                                    <router-link :to="'products/item/'+field.products[5].id">
                                                        <img v-if="field.products[5].images[0]"
                                                        :src="[ field.products[5].images[0].url]">
                                                        <img v-else src="../../assets/img/default-noimg.png">
                                                    </router-link >
                                                </div>
                                            </div>
                                            <div class="col-6 product__content pr-sm-3 pr-1">
                                                <h5 class="ui text big-lg medium-md tiny-sm small semibold ">
                                                    <router-link :to="'products/item/'+field.products[5].id">{{field.products[5].titleTH}}</router-link>
                                                </h5>
                                                <div class="price">
                                                        <p class="ui text big-lg medium-md tiny-sm small bold [ color red-2 ] m-0">{{currency}}{{formatPrice(field.products[5].netPrice)}}</p>
                                                        <p v-if="field.products[5].netPrice != field.products[5].price"  class="ui text big-lg medium-md tiny-sm small light line-through m-0">{{currency}}{{formatPrice(field.products[5].price)}}</p>
                                                    </div>
                                                <div class="d-flex align-items-center">
                                                    <div v-if="field.products[5].discountPercent != 0"><a class="ui yellow label p-sm-2 p-1"><span class="ui text color red-2">{{$t('sale')}} <span class="ui text medium-sm tiny">{{field.products[5].discountPercent}}</span>%</span></a></div>
                                                    <div class="ml-auto">
                                                        <div class="d-flex align-items-center ml-auto">
                                                            <AddToCart v-if="field.products[5].quantity != 0" :btnStyle="'style1'" :product="field.products[5]" />
                                                            <span v-else class="badge badge-danger mr-2">{{$t('SoldOut')}}</span>
                                                            <Favorite :productId="field.products[5].id"></Favorite>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    </div>
</template>
<script>
import AddToCart from '@/components/cart/AddItem.vue'
import Favorite from '@/components/favorite/AddFavorite.vue'

export default {
    name: 'ProductListIIII',
    components: {
        AddToCart,
        Favorite,
    },
    props: {
        field: {
            type: Object,
            default: {
                products: {
                    type: Array,
                    default: () => []
                }
            }
        }
    },
    data () {
        return {
            currency: ''
        }
    },
    created(){
      this.currency = this.$parent.currency
    },
    methods: {
        formatPrice(value) {
            let price = Number(value)
            return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
    }
}
</script>